var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4035 25 25 19.4035 25 12.5C25 5.59643 19.4035 0 12.5 0C5.59643 0 0 5.59643 0 12.5C0 19.4035 5.59643 25 12.5 25Z",
    fill: "#FDDF6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.1786 23.154C8.27505 23.154 2.67865 17.5576 2.67865 10.6541C2.67865 6.9658 4.27639 3.65112 6.81715 1.3631C2.77039 3.43223 0 7.64226 0 12.4994C0 19.4029 5.5964 24.9993 12.4999 24.9993C15.7152 24.9993 18.6465 23.785 20.8614 21.7905C19.1564 22.6622 17.225 23.154 15.1786 23.154Z",
    fill: "#9D4F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3364 10.1546C11.1789 10.1546 11.8619 9.47157 11.8619 8.62904C11.8619 7.78652 11.1789 7.10352 10.3364 7.10352C9.49385 7.10352 8.81085 7.78652 8.81085 8.62904C8.81085 9.47157 9.49385 10.1546 10.3364 10.1546Z",
    fill: "#9D4F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9251 10.1546C19.7676 10.1546 20.4506 9.47157 20.4506 8.62904C20.4506 7.78652 19.7676 7.10352 18.9251 7.10352C18.0825 7.10352 17.3995 7.78652 17.3995 8.62904C17.3995 9.47157 18.0825 10.1546 18.9251 10.1546Z",
    fill: "#9D4F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8391 19.3141C13.4921 19.3141 12.2477 18.5823 11.5916 17.4045C11.4549 17.1592 11.543 16.8495 11.7884 16.7128C12.0336 16.576 12.3434 16.6642 12.48 16.9096C12.9567 17.7654 13.8607 18.297 14.8391 18.297C15.7927 18.297 16.7069 17.76 17.2251 16.8956C17.3696 16.6548 17.6817 16.5764 17.9227 16.7209C18.1636 16.8654 18.2418 17.1777 18.0974 17.4185C17.3964 18.5878 16.148 19.3141 14.8391 19.3141Z",
    fill: "#9D4F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/Happy.b4659e54621e02f5e1bde5be95d89edd.svg";
export { ForwardRef as ReactComponent };